import React, { useContext, useEffect, useState } from "react";
import "./leads.css";
import ProfileHeader from "../../profile/components/ProfileHeader";
import { useOutletContext } from "react-router-dom";
import { LeadsGetAPI } from "../api/LeadsAPI";
import { ProfileContext } from "../../../context/ProfileContext";
import { errorUI } from "../../../styled/Swal";
import { ReferralPartnerUpdateAPI } from "../../../api/ReferralPartnerAPI";

function Leads() {
  const { openSidebar } = useOutletContext();
  const [leads,setLeads] = useState([]);
  const { user, setUser } = useContext(ProfileContext);
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!user?._id) return;

  const fetchLeads = async () => {
      setLoading(true);
      try {
        const res = await LeadsGetAPI();
        if (res?.success) {
          const lead = res?.res?.data?.data || [];

          if(user.type==='referralPartner'){
            const filtered = lead.filter(
              (l) => l.sourceId === user._id
            );
            setLeads(filtered);
            const dbCount = filtered.length;
            const currentCount = user?.performance?.totalLeads ?? 0;

            if (currentCount !== dbCount && dbCount > 0) {
              const payload = {
                performance: {
                  ...user?.performance,
                  totalLeads: dbCount,
                },
              };
              console.log('Update API Call')
              const res = await ReferralPartnerUpdateAPI(user?._id, payload); 
              if(res?.success){
                setUser((prev) => ({
                  ...prev,
                  performance:{
                    totalLeads:filtered.length
                  }
                }));
              }
            }
          }
          else{
            setLeads(lead)
          }
        } else {
          errorUI(res?.message);
        }
      } catch (error) {
        errorUI(error?.message || "Failed to fetch leads");
      } finally {
      setLoading(false);
      }
  };
    fetchLeads();
  }, [user?._id]);


  return (
    <div className="rp-leads-page">
      <ProfileHeader onMenuClick={openSidebar} val="Client Leads" />
      {/* 
      <div className="rp-leads-filter-card">
        <h4 className="rp-leads-filter-title"><Filter size={18}/> Filter Leads : </h4>

        <div className="rp-leads-filters">
          <div className="rp-filter-group">
            <label>Status</label>
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="All">All</option>
              <option value="New">New</option>
              <option value="In Progress">In Progress</option>
              <option value="Converted">Converted</option>
            </select>
          </div>

          <div className="rp-filter-group">
            <label>From Date</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div className="rp-filter-group">
            <label>To Date</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
        </div>
      </div> */}

    <div className="rp-leads-table">
      <div className="rp-leads-header">
        <div>Full Name</div>
        <div>Email</div>
        <div>Phone</div>
        <div>Source</div>
      </div>

      {loading ? (
        <div className="rp-leads-loading">Loading leads...</div>
      ) : leads.length > 0 ? (
        leads.map((lead) => (
          <div className="rp-leads-row" key={lead._id}>
            <div>{lead.fullName}</div>
            <div>{lead.email}</div>
            <div>{lead.mobile}</div>
            <div>{lead.source}</div>
          </div>
        ))
      ) : (
        <div className="rp-leads-empty">No leads found</div>
      )}
    </div>
    </div>
  );
}

export default Leads;
